import { c as _c } from "react/compiler-runtime";
import SettingConfig from '@module/config/setting';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { aspCond } from '@module/helpers/conditions/condition';
import useModalStore from '@module/stores/useModalStore';
function LoginIntro() {
  const $ = _c(4);
  const {
    isLogin
  } = useGetLoginInfoQuery();
  const {
    pushModal
  } = useModalStore(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="text-left text-baseFg">방송시청을 위하여 로그인이 필요합니다.</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isLogin || $[2] !== pushModal) {
    t1 = <div className="mb-[3px] text-center">{t0}<button type="button" className="my-[15px] whitespace-pre-wrap rounded-[10px] bg-colorBg13 px-[17px] py-2 text-[13px] text-colorFg12" onClick={e => {
        if (isLogin) {
          return;
        }
        e.stopPropagation();
        if (aspCond.if("new-asp")) {
          SettingConfig.aspUtils?.goLogin();
          return;
        }
        pushModal({
          type: "AUTH_MODAL",
          id: "LoginIntro"
        });
      }}>{"\uB85C\uADF8\uC778\uD558\uAE30"}</button></div>;
    $[1] = isLogin;
    $[2] = pushModal;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(state) {
  return state;
}
export default LoginIntro;